import { z } from 'zod';

export const InventoryImage = z.object({
  id: z.number().int().positive(),
  inventory_id: z.number().int().positive(),
  position: z.number().int().nonnegative(),
  image_id: z.string().nullable(),
  url: z.string().url(),
});
export type InventoryImage = z.infer<typeof InventoryImage>;

export const InventoryImageInput = z.object({
  url: z.string().url(),
  image_id: z.string().nullable().optional(),
  position: z.number().int().nonnegative().optional(),
});
export type InventoryImageInput = z.infer<typeof InventoryImageInput>;

export const ImageReorderInput = z.object({
  image_ids: z.array(z.number().int().positive()).min(1),
});
export type ImageReorderInput = z.infer<typeof ImageReorderInput>;

export const PartImage = z.object({
  id: z.number().int().positive(),
  part_id: z.number().int().positive(),
  position: z.number().int().nonnegative(),
  image_id: z.string().nullable(),
  url: z.string().url(),
});
export type PartImage = z.infer<typeof PartImage>;

export const PartImageInput = z.object({
  url: z.string().url(),
  image_id: z.string().nullable().optional(),
  position: z.number().int().nonnegative().optional(),
});
export type PartImageInput = z.infer<typeof PartImageInput>;

export const ProductImage = z.object({
  id: z.number().int().positive(),
  product_id: z.number().int().positive(),
  position: z.number().int().nonnegative(),
  image_id: z.string().nullable(),
  url: z.string().url(),
});
export type ProductImage = z.infer<typeof ProductImage>;

export const ProductImageInput = z.object({
  url: z.string().url(),
  image_id: z.string().nullable().optional(),
  position: z.number().int().nonnegative().optional(),
});
export type ProductImageInput = z.infer<typeof ProductImageInput>;
